<!-- Side Menu -->
<div class="row">
  <!-- Side Menu -->
  <div class="col-lg-1 col-12 px-0">
    <app-uiform-side-menu [uiformId]="uiformId" targetId="taskboard">
    </app-uiform-side-menu>
  </div>

  <!-- Main Content -->
  <div class="col-lg-11 col-12 ps-lg-0 my-margin-left">
    <div class="row mt-2">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-3">
            <div class="task-board-container container-fluid">
              <!-- Header -->
              <div class="board-header mb-4">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 class="board-title mb-0">
                      <mat-icon class="me-2">dashboard</mat-icon>
                      {{ board.title }}
                    </h6>
                    <p class="text-muted mb-0">
                      Last updated: {{ board.updatedAt | date: "medium" }}
                    </p>
                  </div>
                  <div class="d-flex gap-2">
                    <button mat-raised-button color="primary" (click)="toggleAddColumn()">
                      <mat-icon>add</mat-icon>
                      <span class="ms-1">Add Column</span>
                    </button>

                    <!-- Add this filter button -->
                    <button mat-stroked-button (click)="toggleFilterPanel()"
                      [color]="showFilterPanel ? 'primary' : 'basic'">
                      <mat-icon>tune</mat-icon>
                      <span class="ms-1">{{
                        showFilterPanel ? "Hide Filters" : "Show Filters"
                        }}</span>
                      <span *ngIf="hasActiveFilters()" class="ms-1 badge bg-primary rounded-pill">!</span>
                    </button>

                    <!-- Search button -->
                    <button mat-stroked-button (click)="toggleSearchPanel()"
                      [color]="showSearchPanel ? 'primary' : 'basic'">
                      <mat-icon>search</mat-icon>
                      <span class="ms-1">{{ showSearchPanel ? "Hide Search" : "Search" }}</span>
                    </button>

                    <button mat-stroked-button color="warn" (click)="resetBoard()">
                      <mat-icon>refresh</mat-icon>
                      <span class="ms-1">Reset Board</span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Add this after the board-header div -->
              <div class="filter-section mb-4" *ngIf="showFilterPanel">
                <div class="card border-0 shadow-md p-1">
                  <div class="card-body">
                    <app-task-search-filter [filterOptions]="filterOptions" [assignees]="getAllAssignees()"
                      (filterChange)="onFilterChange($event)">
                    </app-task-search-filter>
                  </div>
                </div>
              </div>

              <!-- Search Panel -->
              <div class="add-column-form mb-4" *ngIf="showSearchPanel">
                <div class="card">
                  <div class="card-body">
                    <app-task-search-filter [filterOptions]="searchOptions" [assignees]="getAllAssignees()"
                      [searchMode]="true" (filterChange)="onSearchChange($event)">
                    </app-task-search-filter>
                  </div>
                </div>
              </div>

              <!-- Add Column Form -->
              <div class="add-column-form mb-4" *ngIf="isAddingColumn">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-6 col-md-8">
                        <input type="text" class="form-control new-column-input" [(ngModel)]="newColumnTitle"
                          placeholder="Enter column title..." (keyup.enter)="addColumn()"
                          (keyup.escape)="isAddingColumn = false" autofocus />
                      </div>
                      <div class="col-sm-6 col-md-4">
                        <div class="d-flex align-items-center gap-2 mt-sm-0 mt-2">
                          <button mat-raised-button color="primary" (click)="addColumn()" class="w-sm-auto w-100">
                            <mat-icon>add</mat-icon>
                            <span class="ms-1">Add </span>
                          </button>
                          <button mat-stroked-button (click)="isAddingColumn = false" class="w-sm-auto w-100">
                            <mat-icon>close</mat-icon>

                            <span class="ms-1">Cancel</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Kanban Board -->
              <div class="kanban-board" cdkDropListGroup>
                <!-- Added cdkDropList for columns and dropColumn event -->
                <div class="row overflow-auto pb-3" style="min-height: 70vh" cdkDropList
                  [cdkDropListData]="board.columns" (cdkDropListDropped)="dropColumn($event)">
                  <!-- Columns -->
                  <div *ngFor="let column of board.columns; let i = index" class="col-md-6 col-lg-4 col-xl-3" cdkDrag
                    cdkDropList [cdkDropListData]="
                      showFilterPanel || showSearchPanel
                        ? filteredTasks[column.id] || []
                        : column.tasks
                    " [cdkDropListConnectedTo]="getColumnIds()" (cdkDropListDropped)="dropTask($event, column)"
                    [id]="column.id">
                    <!-- Column Header -->
                    <div class="column-header card mb-3">
                      <div class="card-header d-flex justify-content-between align-items-center p-0"
                        [style.background]="column.color + '20'" [style.borderLeft]="'5px solid ' + column.color">
                        <div class="d-flex align-items-center gap-2">
                          <span class="drag-handle" cdkDragHandle>
                            <mat-icon>drag_indicator</mat-icon>
                          </span>
                          <h6 class="mb-0 coltitle">{{ column.title }}</h6>
                          <span class="badge bg-secondary rounded-pill">
                            {{
                            showFilterPanel || showSearchPanel
                            ? filteredTasks[column.id]?.length || 0
                            : column.tasks.length
                            }}
                            <span *ngIf="
                                (showFilterPanel || showSearchPanel) &&
                                filteredTasks[column.id]?.length !==
                                  column.tasks.length
                              ">
                              / {{ column.tasks.length }}
                            </span>
                          </span>
                        </div>
                        <div class="column-actions">
                          <button mat-icon-button class="icon-pd-none" [matMenuTriggerFor]="columnMenu">
                            <mat-icon class="icon-compact text-secondary">more_vert</mat-icon>
                          </button>
                          <mat-menu #columnMenu="matMenu">
                            <button mat-menu-item (click)="editColumn(column)">
                              <mat-icon color="primary" class="icon-compact">edit</mat-icon>
                              <span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="deleteColumn(column.id)">
                              <mat-icon color="warn" class="icon-compact">delete</mat-icon>
                              <span>Delete</span>
                            </button>
                          </mat-menu>
                        </div>
                      </div>

                      <!-- Tasks List -->
                      <div class="card-body p-1" style="
                          min-height: 200px;
                          max-height: 65vh;
                          overflow-y: auto;
                        ">
                        <!-- Tasks - Use filtered tasks when filter panel is open -->
                        <div *ngFor="
                            let task of showFilterPanel || showSearchPanel
                              ? filteredTasks[column.id] || []
                              : column.tasks
                          " class="mb-3">
                          <!-- Added [cdkDragData]="task" here -->
                          <div class="task-card" cdkDrag [cdkDragData]="task">
                            <div class="card-body p-1 bgcolor">
                              <!-- Task Header -->
                              <div class="d-flex justify-content-between align-items-start mb-2">
                                <div class="task-priority">
                                  <span class="priority-badge" [style.background]="
                                      getPriorityColor(task.priority)
                                    ">
                                    {{ getPriorityLabel(task.priority) }}
                                  </span>
                                </div>
                                <div class="task-actions">
                                  <button mat-icon-button color="primary" size="small"
                                    (click)="editTask(task, column.id)">
                                    <mat-icon>edit</mat-icon>
                                  </button>
                                  <button mat-icon-button size="small" (click)="deleteTask(task.id, column.id)"
                                    color="warn">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </div>
                              </div>

                              <!-- Task Content -->
                              <h6 class="task-title mb-2">{{ task.title }}</h6>
                              <p class="task-description text-muted small mb-2" *ngIf="task.description">
                                {{ task.description | slice: 0 : 100
                                }}{{
                                task.description.length > 100 ? "..." : ""
                                }}
                              </p>

                              <!-- Task Footer -->
                              <div class="task-footer mt-3">
                                <div class="d-flex justify-content-between align-items-center">
                                  <div class="task-due-date">
                                    <mat-icon class="me-1 icon-compact">event</mat-icon>
                                    <small [class.text-danger]="
                                        isOverdue(task.dueDate)
                                      ">
                                      {{ formatDate(task.dueDate) }}
                                    </small>
                                  </div>
                                  <div class="task-assignee" *ngIf="task.assignee">
                                    <small class="assignee-badge">
                                      {{ task.assignee | slice: 0 : 1 }}
                                    </small>
                                  </div>
                                </div>

                                <!-- Labels -->
                                <div class="task-labels mt-2" *ngIf="task.labels && task.labels.length">
                                  <span *ngFor="let label of task.labels" class="badge bg-light text-dark me-1">
                                    {{ label }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Empty State -->
                        <div *ngIf="
                            (showFilterPanel || showSearchPanel
                              ? filteredTasks[column.id]?.length
                              : column.tasks.length) === 0
                          " class="empty-column text-center py-4">
                          <mat-icon class="mb-2" style="font-size: 48px; opacity: 0.3">inbox</mat-icon>
                          <p class="text-muted mb-0">
                            {{
                            (showFilterPanel || showSearchPanel) && column.tasks.length > 0
                            ? "No matching tasks"
                            : "No tasks yet"
                            }}
                          </p>
                          <small *ngIf="(showFilterPanel || showSearchPanel) && column.tasks.length > 0"
                            class="text-muted">
                            ({{ column.tasks.length }} total tasks in this
                            column)
                          </small>
                        </div>

                        <!-- Add Task Button -->
                        <div class="add-task-button mt-2">
                          <button mat-stroked-button class="w-100" (click)="addTask(column.id)">
                            <mat-icon>add</mat-icon>
                            Add Task
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Empty Board State -->
                  <div *ngIf="board.columns.length === 0" class="col-12">
                    <div class="empty-board text-center py-5">
                      <mat-icon style="font-size: 64px; opacity: 0.3">dashboard</mat-icon>
                      <h4 class="mt-3">No columns yet</h4>
                      <p class="text-muted">
                        Start by adding your first column
                      </p>
                      <button mat-raised-button color="primary" (click)="toggleAddColumn()">
                        <mat-icon>add</mat-icon>
                        Add First Column
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Footer -->
              <div class="board-footer mt-4 pt-3 border-top">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="text-muted small">
                    <mat-icon class="me-1 icon-compact text-secondary">info</mat-icon>
                    Drag columns to reorder, drag tasks to move between columns
                  </div>
                  <div class="text-muted small">
                    Auto-saved to browser storage
                    <span *ngIf="(showFilterPanel || showSearchPanel) && hasActiveFilters()" class="ms-1 text-primary">
                      • Filters active
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>